module.exports = __webpack_public_path__ + "static/img/banner_aboutus.f7a25cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/banner_aboutus.png
// module id = E6MB
// module chunks = 2